// extracted by mini-css-extract-plugin
export default {"viewColumn":"dashboard_viewColumn__n0H98"};